import { Language } from './base';

const pdash = () => import('../translations/pdash/ur-PK.json');
const webActivities = () => import('../translations/web-activities/ur-PK.json');
const rdashTranslatables = () => import('../translations/rdash-translatables/ur-PK.json');

export default new Language({
    code: 'ur-PK',
    locale: 'ur',
    localName: 'اردو',
    englishName: 'Urdu',
    territory: 'PK',
    timezones: ['Asia/Karachi'],
    notLoadedNamespaces: { pdash, webActivities, rdashTranslatables },
});
